import { format, addDays, setHours, setMinutes } from 'date-fns';

/**
 * Calculate the next available appointment time slot
 * - If before 9 AM: returns 09:00 today
 * - If between 9 AM and 5 PM: rounds up to the next 30-minute slot
 * - If after 5 PM: returns 09:00 tomorrow
 */
export const getNextAvailableTimeSlot = (): { date: string; time: string } => {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();

  const BUSINESS_START = 9;
  const BUSINESS_END = 17;

  let appointmentDate = now;
  let appointmentHour: number;
  let appointmentMinutes: number;

  if (currentHour < BUSINESS_START) {
    appointmentHour = BUSINESS_START;
    appointmentMinutes = 0;
  } else if (currentHour >= BUSINESS_END) {
    appointmentDate = addDays(now, 1);
    appointmentHour = BUSINESS_START;
    appointmentMinutes = 0;
  } else {
    appointmentMinutes = currentMinutes < 30 ? 30 : 0;
    appointmentHour = currentMinutes < 30 ? currentHour : currentHour + 1;

    if (appointmentHour >= BUSINESS_END) {
      appointmentDate = addDays(now, 1);
      appointmentHour = BUSINESS_START;
      appointmentMinutes = 0;
    }
  }

  const timeDate = setMinutes(setHours(appointmentDate, appointmentHour), appointmentMinutes);

  return {
    date: format(appointmentDate, 'yyyy-MM-dd'),
    time: format(timeDate, 'HH:mm'),
  };
};

/**
 * Check if an appointment is a video visit
 * Note: async_message also sets is_telehealth=true, so we must check visit_mode first
 */
export const isVideoVisit = (appointment: { is_telehealth?: boolean; visit_mode?: string }): boolean => {
  // If visit_mode is explicitly set, use it to determine video visit
  if (appointment?.visit_mode) {
    return appointment.visit_mode === 'video';
  }
  // Fall back to is_telehealth for backwards compatibility (legacy appointments without visit_mode)
  return appointment?.is_telehealth === true;
};

/**
 * Check if an appointment is an async messaging consultation
 */
export const isAsyncMessage = (appointment: { visit_mode?: string }): boolean => {
  return appointment?.visit_mode === 'async_message';
};

